import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { ReportPage } from '@/components/reports/report-page'
import { StockOutReport } from '@/components/reports/stock-out/stock-out-report'
import { validateStockOutReportSearch } from '@/components/reports/stock-out/stock-out-report-search'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/stock-out',
)({
    validateSearch: validateStockOutReportSearch,
    component: StockOutReportPage,
})

function StockOutReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.stock_out_report_page_title()}>
            <StockOutReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
